import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import TldrBase from "../TldrLogin/TldrBase";
import { VERIFY_EMAIL } from "../_actions/endpoints";
import { handleHTTPError } from "../_actions/errorHandlerActions";
import {
  REGISTRATION_VERIFICATION_FAILURE,
  REGISTRATION_VERIFICATION_SUCCESS,
} from "../_utils/routes";
import { Button, Center } from "@chakra-ui/react";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import queryString from "query-string";

class ConfirmYourEmailAddress extends Component {
  signal = axios.CancelToken.source();

  constructor(props) {
    super(props);
    const planName = queryString.parse(this.props.location.search).plan_name;
    const promoCode = queryString.parse(this.props.location.search).promo_code;
    this.state = {
      planName: planName,
      promoCode: promoCode,
    };
    this.onClick = this.onClick.bind(this);
  }

  // Confirm email :
  verifyEmailAddress = () => {
    const userData = { key: this.props.match.params.key };
    axios
      .post(VERIFY_EMAIL, userData, { cancelToken: this.signalToken })
      .then((res) => {
        if (this.state.planName)
          localStorage.setItem("planName", this.state.planName);
        if (this.state.promoCode)
          localStorage.setItem("promoCode", this.state.promoCode);
        this.props.history.push(REGISTRATION_VERIFICATION_SUCCESS);
      })
      .catch((error) => {
        if (error?.response?.status === 404) {
          this.props.history.push(REGISTRATION_VERIFICATION_FAILURE);
        } else {
          this.props.handleHTTPError(error, { ...this.props });
        }
      });
  };

  componentDidMount() {
    this.verifyEmailAddress();
  }

  onClick() {
    const userData = { key: this.props.match.params.key };
    this.verifyEmailAddress(userData, this.props.history, this.signal.token);
  }

  componentWillUnmount() {
    this.signal.cancel("The user aborted a request.");
  }
  render() {
    const { t } = this.props;
    return (
      <TldrBase
        wrapperClassName="login-wrapper"
        showBackgroundImage
        heading={t("confirm_email.heading")}
        subheading={t("confirm_email.subheading")}
      >
        <Center my={3}>
          <Button type="submit" variant="solid" size="lg" isLoading></Button>
        </Center>
      </TldrBase>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleHTTPError: (error, props) => dispatch(handleHTTPError(error, props)),
  };
};

export default connect(
  mapDispatchToProps,
  mapDispatchToProps
)(withRouter(withTranslation(["auth"])(ConfirmYourEmailAddress)));
